import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TranslateDialogViewModel from "./../factories/translate-dialog";
function IndicatorViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Indicator())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.Indicator = ko.observable();
    self.Indicator1 = ko.observable();
    self.Indicator2 = ko.observable();
    self.Indicator3 = ko.observable();
    self.Indicator4 = ko.observable();
    self.Indicator5 = ko.observable();
    self.Indicator.subscribe(function () {
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.Indicator1(self.Indicator());
                break;
            case 2:
                self.Indicator2(self.Indicator());
                break;
            case 3:
                self.Indicator3(self.Indicator());
                break;
            case 4:
                self.Indicator4(self.Indicator());
                break;
            case 5:
                self.Indicator5(self.Indicator());
                break;
        }
    });
    self.IndicatorComputed = ko.computed(function () {
        self.Indicator1();
        self.Indicator2();
        self.Indicator3();
        self.Indicator4();
        self.Indicator5();
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.Indicator(self.Indicator1());
                break;
            case 2:
                self.Indicator(self.Indicator2());
                break;
            case 3:
                self.Indicator(self.Indicator3());
                break;
            case 4:
                self.Indicator(self.Indicator4());
                break;
            case 5:
                self.Indicator(self.Indicator5());
                break;
        }
    });
    self.Translate = function () {
        var translateDialog = new TranslateDialogViewModel(self.Indicator1, self.Indicator2, self.Indicator3, self.Indicator4, self.Indicator5);
        translateDialog.Open().then(function () { });
    };
}
Bao.inherit(IndicatorViewModel, SearchPaging);
IndicatorViewModel.prototype.PrimaryKey = "ConfigurationItemIndicatorId";
IndicatorViewModel.prototype.RefreshUrl = "Indicator/GetConfigurationItemIndicator";
IndicatorViewModel.prototype.SaveUrl = "Indicator/SaveConfigurationItemIndicator";
IndicatorViewModel.prototype.DeleteUrl = "Indicator/DeleteConfigurationItemIndicator";
IndicatorViewModel.prototype.IsInUseUrl = "Indicator/IsIndicatorInUse";
IndicatorViewModel.prototype.PermissionForward = "ConfigurationItemIndicatorMoveForwardSearch";
IndicatorViewModel.prototype.PermissionBackward = "ConfigurationItemIndicatorMoveBackwardSearch";
IndicatorViewModel.prototype.PermissionSave = "ConfigurationItemIndicatorSave";
IndicatorViewModel.prototype.PermissionRefresh = "ConfigurationItemIndicatorRefresh";
IndicatorViewModel.prototype.PermissionDelete = "ConfigurationItemIndicatorDelete";
export default IndicatorViewModel;